import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuAdminComponent } from '../menu-admin/menu-admin.component';
import { SidebarAdminComponent } from '../sidebar-admin/sidebar-admin.component';
import { AuthService } from '../../auth/services/auth.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, MenuAdminComponent, SidebarAdminComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

  authService = inject(AuthService);

  ngOnInit(): void {
    this.authService.validateAuth().subscribe(response => {

    });
  }

}
